import {createSlice} from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";


const persistConfig = {
  key: "user-access-key", 
  storage,
  whitelist: ["accessToken","refreshToken","isUserAuthenticated","user","listLoading","actionsLoading","lastError","userName","sessionKey"]
};

const initialState = {
  listLoading: false,
  actionsLoading: false,
  isUserAuthenticated: false,
  user: undefined,
  userName: undefined,
  sessionKey: undefined,
  lastError: null,
  logos:[],
  logosCount:undefined,
  logo: undefined
};

export const callTypes = {
  list: "list",
  action: "action"
};
  

const authSlice = createSlice({
  
    name: 'authSlice',
    initialState:initialState,
    reducers: {
        catchError: (state, action) => {
          state.lastError = `${action.type}: ${action.payload.error}`;
          if (action.payload.callType === callTypes.list) {
            state.listLoading = false;
          } else {
            state.actionsLoading = false;
          }
          state.isUserAuthenticated = false;
          state.accessToken = undefined;
          state.refreshToken = undefined;
          state.userName = undefined;
          state.sessionKey = undefined;
          state.user = undefined;
        },
        startCall: (state, action) => {
          state.lastError = null;
          if (action.payload.callType === callTypes.list) {
            state.listLoading = true;
          } else {
            state.actionsLoading = true;
          }
        },
        loginSuccess: (state, action) => {
          const { data, username, key } = action.payload;
          state.actionsLoading = false;
          state.lastError = null;
          state.userName = username;
          state.sessionKey = key;
          state.isUserAuthenticated = true;
          state.user = data;   
        },
        userLoaded: (state, action) => {
          const {  user } = action.payload;
          state.actionsLoading = false;
          state.isUserAuthenticated = true;
          state.lastError = null;
          state.user = user;   
        },
        logosLoaded: (state, action) => {
          const { logos, logosCount } = action.payload;
          state.actionsLoading = false;
          state.logos = logos;
          state.logosCount = logosCount;
          state.lastError = null;
        },
        logoLoaded: (state, action) => {
          const { logo } = action.payload;
          state.actionsLoading = false;
          state.logo = logo;
          state.lastError = null;
        },
        loggedOut: () =>  initialState
          // From here we can take action only at this "counter" state
          // But, as we have taken care of this particular "logout" action
          // in rootReducer, we can use it to CLEAR the complete Redux Store's state
        
        ,
        
        
      }
});

const unpersistedReducer = authSlice.reducer;
export const reducer = persistReducer(persistConfig, unpersistedReducer);
export const {actions} = authSlice;
